module.exports = __webpack_public_path__ + "static/media/altres.88752eff.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/avis/altres.svg
// module id = 829
// module chunks = 0